import React from 'react'
import { CircularProgress } from '@mui/material'
import { useStyles } from './styles'

interface CustomButtonProps {
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
  className?: string
  children?: React.ReactNode
  secondary?: boolean
  outlined?: boolean
  id?: string
  disabled?: boolean
  style?: React.CSSProperties
  type?: 'button' | 'submit' | 'reset'
  isLoading?: boolean
}

export const Button: React.FC<CustomButtonProps> = ({
  onClick,
  className,
  children,
  secondary = false,
  outlined = false,
  disabled,
  isLoading = false,
  style,
  ...rest
}) => {
  const classes = useStyles({ secondary, outlined })

  const buttonClasses = [
    classes.customButtonWrapper,
    outlined ? classes.outlinedButtonWrapper : '',
    disabled ? classes.customButtonDisabled : '',
    className
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <button onClick={onClick} className={buttonClasses} disabled={disabled || isLoading} style={style} {...rest}>
      <span
        className={classes.content}
        style={{
          opacity: isLoading ? 0 : 1,
          display: 'flex',
          gap: 4
        }}
      >
        {children}
      </span>

      {isLoading && (
        <span className={classes.loader}>
          <CircularProgress size={16} color='inherit' />
        </span>
      )}
    </button>
  )
}
;('')
